'use client';

import { useDrawerStore } from '@/stores';

import { PolicyDrawer } from '../PolicyDrawer';

const policyDrawerConfig = {
  title: 'Políticas e Privacidade',
  Component: PolicyDrawer,
  drawerType: 'policy',
} as const;

export const usePolicyDrawer = () => {
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const replaceDrawer = useDrawerStore((state) => state.replaceDrawer);
  const drawers = useDrawerStore((state) => state.drawers);

  const openPolicyDrawer = () => {
    const hasOpenDrawer = drawers.length > 0;
    if (hasOpenDrawer) {
      replaceDrawer(policyDrawerConfig);
    } else {
      openDrawer(policyDrawerConfig);
    }
  };

  return { openPolicyDrawer };
};
